var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLife(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6702 6.2113C14.8668 6.96631 14.309 7.64965 13.6067 7.64965H2.39316C1.69088 7.64965 1.13311 6.96631 1.32968 6.2113C1.68567 4.84392 2.37277 3.6025 3.32626 2.63182C4.60517 1.32983 6.27153 0.608398 7.99993 0.608398C9.72834 0.608398 11.3947 1.32983 12.6736 2.63182C13.6271 3.6025 14.3142 4.84392 14.6702 6.2113Z",
    fill: "#696970"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.7957C12 13.3262 11.7893 13.8349 11.4142 14.2099C11.0391 14.585 10.5304 14.7957 10 14.7957C9.46957 14.7957 8.96086 14.585 8.58579 14.2099C8.21071 13.8349 8 13.3262 8 12.7957V7.4624",
    stroke: "#696970",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLife);
export default __webpack_public_path__ + "static/media/life.d6eabb0092831a0feb7d0a65bb5a4207.svg";
export { ForwardRef as ReactComponent };